// This component has been introduced for testing purpose
import { Component } from '@angular/core';

@Component({
    selector: 'not-found',
    template: `
        <div>
          <h3> Data Protection: Not Found</h3>
        </div>`
})

export default class NotFound {

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/not-found.component.ts